import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Branded short-link redirect for affiliate partners.
 * `theailedger.ai/go/marblism` → hits our backend tracker (`/api/affiliate-partners/go/marblism`)
 * which logs the click, then 302s to the partner's actual affiliate URL.
 *
 * We intentionally don't render anything meaningful — most users never see this
 * page because the browser follows the redirect before paint.
 */
export default function AffiliateGoRedirect() {
  const { slug } = useParams();
  useEffect(() => {
    if (!slug) return;
    const safe = slug.toLowerCase().replace(/[^a-z0-9-]/g, '');
    if (safe) {
      window.location.replace(`${API_URL}/api/affiliate-partners/go/${safe}`);
    }
  }, [slug]);

  return (
    <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center">
      <div className="text-center space-y-3" data-testid="affiliate-go-redirect">
        <div className="w-10 h-10 border-4 border-[#00F0FF] border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="text-sm text-neutral-400">Taking you to our partner…</p>
      </div>
    </div>
  );
}
